module.exports = __webpack_public_path__ + "img/mistakesText13.2f33a6f5.png";